import { useTranslation } from "@opendash/i18n";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../../context/PathContext";

type Props = {};

export const MetaFieldDescription = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <Form.Item
      label={t("maintenance:ticket_creation.fields.meta.fields.description")}
      name={[...path, "description"]}
      style={{ width: "100%" }}
    >
      <Input />
    </Form.Item>
  );
});
